import type {
  AssignRequesterCustomerCommitPayload,
  AssignRequesterCustomerDraft,
} from "../contract"

const optionalText = (value: string) => value.trim() || null

export const assignRequesterCustomerPayload = (
  draft: AssignRequesterCustomerDraft,
): AssignRequesterCustomerCommitPayload => {
  if (!draft.decision) throw new Error("Ansprechpartner-Entscheidung fehlt.")

  if (draft.decision === "use_existing") {
    return {
      decision: "use_existing",
      customer_id: draft.customerId,
      contact_email: optionalText(draft.email),
      contact_phone: optionalText(draft.phone),
      property_customer_role: draft.role || null,
    }
  }

  return {
    decision: "create_new",
    create_customer: { display_name: draft.displayName.trim() },
    contact_email: optionalText(draft.email),
    contact_phone: optionalText(draft.phone),
    property_customer_role: draft.role || null,
  }
}
